<ejs-dialog #emailPreviewDialog [isModal]="true" [showCloseIcon]="true" [visible]="false" (close)="cancelClicked()"
  (open)="onOpen($event)">
  <ng-template #header>
    {{
    'i18n.domain.export-configuration.activation-emails.preview-dialog.title' | translate }}
  </ng-template>

  <ng-template #content>
    <form [formGroup]="activationEmailForm">
      <div class="form-row row">
        <div class="form-group col-12">
          <label for="emailTo" class="control-label">
            {{ 'i18n.domain.export-configuration.activation-emails.form-fields.email-to' | translate }}
          </label>
          <input id="emailTo" type="text" class="form-control" formControlName="emailTo" />
        </div>
      </div>
      <div class="form-row row">
        <div class="form-group col-12">
          <label for="subject" class="control-label required">
            {{ 'i18n.domain.export-configuration.activation-emails.form-fields.subject' | translate }}
          </label>
          <input id="subject" type="text" class="form-control" formControlName="subject" />
          <app-error-messages [control]="activationEmailForm.get('subject')"></app-error-messages>
        </div>
      </div>
      <div class="form-row row">
        <div class="form-group col-12">
          <label for="emailContent" class="control-label">
            {{ 'i18n.domain.export-configuration.activation-emails.form-fields.body' | translate }}
          </label>
          @if (renderRTE) {
            <ejs-richtexteditor #emailContent
                                id="emailContent"
                                formControlName="emailContent"
                                [insertImageSettings]='insertImageSettings'
                                [toolbarSettings]='tools'
                                (actionComplete)="onActionComplete($event)">
            </ejs-richtexteditor>
          }
          <app-error-messages [control]="activationEmailForm.get('emailContent')"></app-error-messages>
        </div>
      </div>
      @if (activationEmails?.length > 1) {
        <div class="form-row row">
          <div class="d-flex justify-content-evenly">
            <button class="e-control e-btn e-lib e-secondary e-flat" [disabled]="currentActivationEmailIndex === 0"
              (click)="previousEmailClicked()">{{
            'i18n.domain.export-configuration.activation-emails.buttons.previous-button' | translate }}</button>
            <button class="e-control e-btn e-lib e-secondary e-flat"
              [disabled]="currentActivationEmailIndex >= activationEmails?.length - 1" (click)="nextEmailClicked()">{{
            'i18n.domain.export-configuration.activation-emails.buttons.next-button' | translate }}</button>
          </div>
        </div>
      }
    </form>
  </ng-template>

  <ng-template #footerTemplate>
    <ng-container>
      @if (!sendAllowed) {
        <label class="text-danger">{{
        'i18n.domain.export-configuration.activation-emails.preview-dialog.send-not-allowed-message' | translate }}</label>
      }
      @if (sendAllowed) {
        <button class="e-control e-btn e-lib e-primary e-flat" (click)="sendClicked()">{{
        'i18n.domain.export-configuration.activation-emails.buttons.send-button' | translate }}</button>
      }
      @if (activationEmails?.length > 1 && sendAllowed) {
        <button class="e-control e-btn e-lib e-primary e-flat" (click)="sendAllClicked()"
          >{{
        'i18n.domain.export-configuration.activation-emails.buttons.send-all-button' | translate }}</button>
      }
      <button class="e-control e-btn e-lib e-flat" (click)="cancelClicked()">{{'i18n.shared.cancel' |
      translate}}</button>
    </ng-container>
  </ng-template>
</ejs-dialog>
